/* eslint-disable react/prop-types */
import React from 'react';

import { pluralize } from 'utils/string';

import Tooltip from 'components/common/tooltip';

import { MY_TEAM_LABELS, TEAM_COUNT_LABEL, TEAM_COUNT_LABEL_SHORT } from 'constants/myTeam';

import { UiScroll, UiSort } from '@vyaguta/vyaguta-icons/ui';
import { TeamGroup } from '../types';

interface MyTeamHeaderProps {
  myTeamCount: Map<string, Set<number>>;
  currentDayMonthDate: string;
  isAnyAccordionOpen: boolean;
  allCollapsed: boolean;
  displayGroups: TeamGroup[];
  onToggleAllAccordions: () => void;
}

const MyTeamHeader: React.FC<MyTeamHeaderProps> = ({
  myTeamCount,
  currentDayMonthDate,
  isAnyAccordionOpen,
  allCollapsed,
  displayGroups,
  onToggleAllAccordions,
}) => {
  const isSingleGroup = displayGroups.length === 1;
  const toggleLabel = isAnyAccordionOpen ? MY_TEAM_LABELS.COLLAPSE_ALL : MY_TEAM_LABELS.EXPAND_ALL;

  // Check if any key in myTeamCount has a non-falsy value in
  // TEAM_COUNT_LABEL_SHORT for the logic to display the divider
  const hasMatchingKey = Array.from(myTeamCount.keys()).some((key) =>
    Boolean(TEAM_COUNT_LABEL_SHORT[key as keyof typeof TEAM_COUNT_LABEL_SHORT])
  );

  return (
    <div className="full-scope-card__header table-header name-wrap">
      <div className="my-team__header d-flex align-items-center justify-content-between f-wrap gap-y-8">
        <div className="my-team__header-heading">
          <div className="table-title-left d-flex my-team__title-left-lock">
            <p className="table-title">{MY_TEAM_LABELS.PAGE_TITLE} </p>
          </div>
          {hasMatchingKey && <span className="my-team__header-divider" />}
          <div className="d-flex gap-x-6 cursor-pointer align-items-center justify-content-between">
            {[...myTeamCount].map(([relation, count]) =>
              TEAM_COUNT_LABEL_SHORT[relation] ? (
                <Tooltip
                  key={relation}
                  html={
                    <div className="tooltip-info">
                      <p className="tooltip-info__title">{TEAM_COUNT_LABEL[relation]}</p>
                      <p>
                        {count.size} {pluralize('Leapfrogger', count.size)}
                      </p>
                    </div>
                  }
                >
                  <div className="my-team__header-count">
                    <span>{TEAM_COUNT_LABEL_SHORT[relation]}: </span>
                    <span>{count.size}</span>
                  </div>
                </Tooltip>
              ) : null
            )}
          </div>
        </div>
        <div className="table-title-right r-right d-flex align-items-center justify-content-center">
          <div className="my-team__sub-header d-flex align-items-center">
            <div className="badge__label my-team__header-badge">
              <span className="my-team__header-date">
                <span className="today">{MY_TEAM_LABELS.TODAY} &middot;&nbsp;</span>
                <span> {currentDayMonthDate}</span>
              </span>

              {displayGroups.length > 0 && !isSingleGroup && (
                <>
                  <span className="my-team__header-divider" />
                  <button type="button" onClick={onToggleAllAccordions} className="my-team__header-toggle">
                    <span className="my-team__header-toggle-icon">{allCollapsed ? <UiSort /> : <UiScroll />}</span>
                    {toggleLabel}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyTeamHeader;
